// src/hooks/useRouteTour.js
import { useState, useEffect, useCallback } from 'react';
import { getTourState, saveTourState, resetTourState } from '../utils/tourStorage';

export default function useRouteTour(routeKey, steps) {
  const saved = getTourState(routeKey);

  const [run, setRun] = useState(saved.run && Array.isArray(steps) && steps.length > 0);
  const [stepIndex, setStepIndex] = useState(saved.stepIndex || 0);
  const [completed, setCompleted] = useState(saved.completed || false);

  useEffect(() => {
    saveTourState(routeKey, { run, stepIndex, completed });
  }, [routeKey, run, stepIndex, completed]);

  const callback = useCallback((data) => {
    const { type, index, status, step } = data;

    // After each step, persist next index
    if (type === 'step:after') {
      setStepIndex(index + 1);
      if (index === 0 && step.id === 'create_application_button') {
        const btn = document.querySelector('.create_application_button');
        if (btn) {
          btn.click();
        }
      }
      if (index === 2 && step.id === 'final_lodgement_button') {
        const btn = document.querySelector('.modal-close-btn');
        if (btn) {
          btn.click();
        }
      }
    }
    // finished or skipped
    if (status === 'finished' || status === 'skipped') {
      setRun(false);
      setCompleted(true);
    }
  }, []);

  const restart = useCallback(() => {
    resetTourState(routeKey);
    setStepIndex(0);
    setCompleted(false);
    setRun(true);
  }, [routeKey]);

  return { run, stepIndex, callback, restart, completed, setRun, setStepIndex };
}
